'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { BasicImage } from '@/components/page-builder/components/BasicImage';
import { NAVBAR_TEST_IDS } from '@/lib/test-ids';
import AppLink from '../AppLink';
interface LogoProps {
  logo?: Data.Component<'utilities.basic-image'> | null;
}
export function Logo(t0) {
  const $ = _c(2);
  const {
    logo
  } = t0;
  if (!logo) {
    return null;
  }
  let t1;
  if ($[0] !== logo) {
    t1 = <AppLink variant="none" href="/" className="h-6 w-27.5 lg:h-9 lg:w-33.5 rounded-none" data-test-id={NAVBAR_TEST_IDS.LOGO} tabIndex={0}><BasicImage component={logo} className="object-contain" fill={true} /></AppLink>;
    $[0] = logo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}